import dynamic from 'next/dynamic'
import { Image } from '@emotion-icons/boxicons-solid/Image'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/generic-map-backdrop.png'

const InsightImage = dynamic(() => import('src/components/insight-image'), { ssr: false })

type RemoveType = Omit<InsightBuilderWidget, 'type'>
type ImageOnlyWidget = RemoveType & { type: 'Image' }

export const InsightImageWidget: Readonly<ImageOnlyWidget> = {
  id: 'insight-image',
  name: 'Image',
  type: 'Image',
  icon: Image,
  component: InsightImage as any,
  preview,
  supportedResultTypes: [],
} as const
